import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from 'shared';

export const appInfoInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const environment: any = inject(ENVIRONMENT);
  const appVersion = environment?.version;
  const appId = environment?.appId;

  const headers = [
    { key: 'X-App-Version', value: appVersion },
    { key: 'X-App-Id', value: appId },
  ].reduce((acc: { [key: string]: string }, { key, value }) => {
    if (value && String(value).trim() !== '') {
      acc[key] = String(value);
    }
    return acc;
  }, {});

  if (req.url.startsWith(environment?.serverUrl || '') && Object.keys(headers).length > 0) {
    const cloned = req.clone({ setHeaders: headers });
    return next(cloned);
  }

  return next(req);
};